import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
}
const MafoQuestionTwo: React.FC<MafoQuestionProps> = ({ register, errors }) => {
	return (
		<>
			<h3 className="mafo-headline text-left text-blue">2. Wie häufig kaufst Du Protein- oder Müsliriegel?</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Mehrmals pro Woche</>} className=" pb-2 text-green" hasError={errors.question2} errMsg={"Bitte akzeptiere die Teilnahmebedingungen."}>
					<input
						{...register("question2")}
						type="radio"
						name="question2"
						required="required"
						value="a"
						className={"peer absolute hidden h-1 w-1 " + (errors.question2 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Etwa einmal pro Woche</>} className=" pb-2 text-green">
					<input
						type="radio"
						{...register("question2")}
						name="question2"
						required="required"
						value="b"
						className={"peer absolute hidden h-1 w-1 " + (errors.question2 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Etwa einmal pro Monat</>} className=" pb-2 text-green">
					<input
						type="radio"
						{...register("question2")}
						name="question2"
						required="required"
						value="c"
						className={"peer absolute hidden h-1 w-1 " + (errors.question2 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Seltener als einmal pro Monat</>} className=" pb-2 text-green">
					<input
						type="radio"
						{...register("question2")}
						name="question2"
						required="required"
						value="d"
						className={"peer absolute hidden h-1 w-1 " + (errors.question2 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Eigentlich nie</>} className=" pb-2 text-green">
					<input
						type="radio"
						{...register("question2")}
						name="question2"
						required="required"
						value="e"
						className={"peer absolute hidden h-1 w-1 " + (errors.question2 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
			</div>
		</>
	)
}

export default MafoQuestionTwo
